// src/views/Home.js
import React from 'react';
import { ShieldCheck, Clock, Wrench, ChevronRight } from 'lucide-react';
import styles from '../css/Home.module.css';
import Navbar from '../components/Navbar';
import GalleryPage from './GalleryPage';
import ContactPage from './ContactPage';
import ServicesPage from './ServicePage';
import Partners from '../components/Partners';

const HomePage = () => {
    return (
        <div className={styles.homeContainer} id="home">
            {/* Hero Section */}
            <section className={styles.hero}>
                <div className={styles.overlay}>
                    <div className={styles.heroContent}>
                        <span className={styles.badge}>AKC Motor</span>
                        <h1>Motorunuzun Performansını <br /> <span>Zirveye Taşıyın</span></h1>
                        <p>15 yıllık tecrübe ve son teknoloji arıza tespit cihazlarımızla, motorunuzdaki her sorunu kökten çözüyoruz.</p>
                        <div className={styles.heroBtns}>
                            <a href="tel:+905426429466" className={styles.primaryBtn}>Randevu Al<ChevronRight size={20} /></a>
                            <a className={styles.secondaryBtn} href="#services">Hizmetlerimiz</a>
                        </div>
                    </div>
                </div>
            </section>
            {/* Michelin Logosunun Olduğu Kısım */}
            <Partners />
            <section id="home">
                {/* Features Section */}
                <section className={styles.features}>
                    <div className={styles.featureCard}>
                        <ShieldCheck size={40} color="#e11d48" /> {/* Daha canlı bir kırmızı */}
                        <h3>%100 Memnuniyet</h3>
                        <p>Bizim için motorun çıkardığı sesten ziyade, dükkandan çıkan müşterinin yüzündeki gülümseme önemli.</p>
                    </div>
                    <div className={styles.featureCard}>
                        <Clock size={40} color="#5f130e" />
                        <h3>Hızlı Teslimat</h3>
                        <p>Motorunuzu en kısa sürede, söz verdiğimiz saatte size teslim ediyoruz.</p>
                    </div>
                    <div className={styles.featureCard}>
                        <Wrench size={40} color="#e11d48" />
                        <h3>Kusursuz İşçilik</h3>
                        <p>Michelin bayiliğimiz ve tecrübemizle, motorunuza bir makine gibi değil, bir tutku gibi bakıyoruz.</p>
                    </div>
                </section>
            </section>



            <section id="services">
                <ServicesPage />
            </section>

            <section id="gallery">
                <GalleryPage />
            </section>

            <section id="contact">
                <ContactPage />
            </section>
        </div>
    );
};

export default HomePage;